export const INSURANCE_SLAB_ACTIONS = {
    INSURANCE_SLAB_SEARCH: 'INSURANCE_SLAB_SEARCH',
    INSURANCE_SLAB_SEARCH_SUCCESS: 'INSURANCE_SLAB_SEARCH_SUCCESS',
    INSURANCE_SLAB_SEARCH_ERROR: 'INSURANCE_SLAB_SEARCH_ERROR',

    INSURANCE_SLAB_UPSERT: 'INSURANCE_SLAB_UPSERT',
    INSURANCE_SLAB_UPSERT_SUCCESS: 'INSURANCE_SLAB_UPSERT_SUCCESS',
    INSURANCE_SLAB_UPSERT_ERROR: 'INSURANCE_SLAB_UPSERT_ERROR',

    INSURANCE_SLAB_EDIT: 'INSURANCE_SLAB_EDIT',

    INSURANCE_SLAB_RESET: 'INSURANCE_SLAB_RESET',
};

export const insuranceSlabResetAction = () => ({
    type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_RESET,
});

export const insuranceSlabSearchAction = (payload) => ({
    type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH,
    ...payload,
});

export const insuranceSlabEditAction = (payload) => ({
    type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_EDIT,
    ...payload,
});

export const insuranceSlabUpsertAction = (payload) => ({
    type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT,
    ...payload,
});

export default {
    INSURANCE_SLAB_ACTIONS,
    insuranceSlabSearchAction,
    insuranceSlabUpsertAction,
    insuranceSlabEditAction,
    insuranceSlabResetAction,
};
